import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import PageWrapper from "../../components/common/layout/PageWrapper";
import { baseEndpointPaths, getApplicationById } from "../../../services/serviceCalls";
import RudiAdditionalDocView from "../../components/services/additionalDoc/RudiAdditionalDocView";

const RudiAdditionalDocViewPage = ({ titleCode }) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  return (
    <PageWrapper title={t(`${titleCode}.view`)}>
      <RudiAdditionalDocView serviceFn={getApplicationById(baseEndpointPaths.rudiAdditionalDoc, id)} />
    </PageWrapper>
  );
};
export default RudiAdditionalDocViewPage;
